// src/components/admin/AdminNav.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Dynamically load FontAwesome CDN if it's not already included globally
function loadFontAwesome() {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
  document.head.appendChild(link);
}

export default function AdminNav() {
  useEffect(() => {
    // Load FontAwesome icons dynamically when the component mounts
    loadFontAwesome();
  }, []);

  // Retrieve the logged-in user's data from localStorage
  const user = JSON.parse(localStorage.getItem('user'));
  const role = user?.role;

  if (!role) return null; // Don't render anything if the user is not logged in

  const isSuperAdmin = role === 'superadmin';

  return (
    <nav className="bg-white border-b shadow w-full mb-6">
      <div className="max-w-5xl mx-auto flex space-x-8 px-4 py-3 text-sm font-medium text-gray-600">

        {/* Superadmin only */}
        {isSuperAdmin && (
          <>
            <Link
              to="/admin"
              className="hover:text-green-700 flex items-center space-x-1"
              title="Dashboard"
            >
              <i className="fas fa-tachometer-alt text-lg" /> {/* FontAwesome icon */}
              <span>Dashboard</span>
            </Link>
            <Link
              to="/admin/suppliers"
              className="hover:text-green-700 flex items-center space-x-1"
              title="Manage Suppliers"
            >
              <i className="fas fa-industry text-lg" /> {/* FontAwesome icon */}
              <span>Manage Suppliers</span>
            </Link>
            <Link
              to="/admin/pending-admins"
              className="hover:text-green-700 flex items-center space-x-1"
              title="Pending Admins"
            >
              <i className="fas fa-user-shield text-lg" /> {/* FontAwesome icon */}
              <span>Pending Admins</span>
            </Link>
          </>
        )}

        {/* Common for both superadmin and supplieradmin */}
        <Link
          to="/admin/create-group"
          className="hover:text-green-700 flex items-center space-x-1"
          title="Create Group"
        >
          <i className="fas fa-folder-plus text-lg" /> {/* FontAwesome icon */}
          <span>Create Group</span>
        </Link>
        <Link
          to="/admin/groups"
          className="hover:text-green-700 flex items-center space-x-1"
          title="Manage Groups"
        >
          <i className="fas fa-cogs text-lg" /> {/* FontAwesome icon */}
          <span>Manage Groups</span>
        </Link>
        <Link
          to="/admin/users"
          className="hover:text-green-700 flex items-center space-x-1"
          title="Manage Users"
        >
          <i className="fas fa-users text-lg" /> {/* FontAwesome icon */}
          <span>Manage Users</span>
        </Link>

      </div>
    </nav>
  );
}
